module.exports = __webpack_public_path__ + "static/media/24UHCHR16.9668143f.jpg";